/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiStringValues
 */
export interface ApiStringValues {
  /**
   *
   * @type {Array<string>}
   * @memberof ApiStringValues
   */
  values?: Array<string>;
}

/**
 * Check if a given object implements the ApiStringValues interface.
 */
export function instanceOfApiStringValues(value: object): value is ApiStringValues {
  return true;
}

export function ApiStringValuesFromJSON(json: any): ApiStringValues {
  return ApiStringValuesFromJSONTyped(json, false);
}

export function ApiStringValuesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiStringValues {
  if (json == null) {
    return json;
  }
  return {
    values: json['values'] == null ? undefined : json['values'],
  };
}

export function ApiStringValuesToJSON(json: any): ApiStringValues {
  return ApiStringValuesToJSONTyped(json, false);
}

export function ApiStringValuesToJSONTyped(
  value?: ApiStringValues | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    values: value['values'],
  };
}
